// store/modules/templateFolders.js
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        folders: {},
        fetchedTypes: [],
    },
    mutations: {
        // Replaces the full by-type slice (not a pure accumulate-merge): a folder deleted or
        // renamed server-side must disappear/update here too, not linger forever because it was
        // once merged in from a stale localStorage cache (see ensureTypeLoaded).
        replaceTypeFolders(state, { type, folders }) {
            const next = {};
            Object.values(state.folders).forEach((folder) => {
                if (folder.type !== type) next[folder.id] = folder;
            });
            folders.forEach((folder) => { next[folder.id] = folder; });
            state.folders = next;
        },
        markTypeFetched(state, type) {
            if (!state.fetchedTypes.includes(type)) {
                state.fetchedTypes = [...state.fetchedTypes, type];
            }
        },
        upsertFolder(state, folder) {
            state.folders = { ...state.folders, [folder.id]: folder };
        },
        removeFolder(state, id) {
            const folders = { ...state.folders };
            delete folders[id];
            state.folders = folders;
        },
    },
    getters: {
        getFolders(state) {
            return state.folders;
        },
        getFoldersList(state) {
            return Object.values(state.folders);
        },
        getFoldersByType(state) {
            return (type) => Object.values(state.folders).filter((folder) => folder.type === type);
        },
        getChildFolders(state) {
            return (type, parentId) => Object.values(state.folders)
                .filter((folder) => folder.type === type && (folder.parent_id || null) === (parentId || null))
                .sort((a, b) => a.position - b.position);
        },
        isTypeFetched(state) {
            return (type) => state.fetchedTypes.includes(type);
        },
    },
    actions: {
        async fetchFolders({ commit }, type) {
            try {
                const { data } = await axios.get(`${process.env.VUE_APP_API_HOST}/template-folders`, {
                    params: { type },
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                });

                commit('replaceTypeFolders', { type, folders: data.folders || [] });
                commit('markTypeFetched', type);

                try {
                    localStorage.setItem(`templateFolders_${type}`, JSON.stringify(data.folders || []));
                } catch (e) {
                    console.error('localStorage quota exceeded, template folders cache not updated:', e);
                }
            } catch (error) {
                console.error('Error fetching template folders:', error);
            }
        },

        async ensureTypeLoaded({ dispatch, commit, getters }, type) {
            if (getters.isTypeFetched(type)) return;

            const cached = localStorage.getItem(`templateFolders_${type}`);

            if (cached) {
                try {
                    commit('replaceTypeFolders', { type, folders: JSON.parse(cached) });
                    commit('markTypeFetched', type);
                } catch (e) {
                    console.error('Invalid template folders cache:', e);
                }
                dispatch('fetchFolders', type);
            } else {
                await dispatch('fetchFolders', type);
            }
        },
    },
};
